import '/public/static/css/module/tab_list_item.scss';

const SoopLoadingSpinner = ({theme}) => {
  return (
    <div className={`loading-spinner ${theme === 'dark' ? 'dark' : ''}`}>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
    </div>
  );
};

export default SoopLoadingSpinner;
